import { Component } from '@angular/core';

@Component({
  selector: 'app-menu-button',
  templateUrl: './menu-button.component.html',
  styleUrls: ['./menu-button.component.scss'], // Corrected: `styleUrl` -> `styleUrls`
})
export class MenuButtonComponent {}
